





































import Vue, { PropOptions } from 'vue';
import { VueEditor } from 'vue2-editor';
import ProductSalesPageUploader from '@/web/components/products/sales-page/ProductSalesPageUploader.vue';

interface ProductResultsProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageResults',
  components: { VueEditor, ProductSalesPageUploader },
  props: {
    value: {
      type: Object as () => ProductSalesPageResultsResponse,
    },
  } as ProductResultsProps,
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
